import { filter } from "lodash";
import { getAuthentication } from "../../lib/auth";
import { BETTING_WEBSITE_RELATIVES_URL } from "../../lib/env";
import { gqlRequest, escapeGqlString } from "../../lib/functions";
import { BETTINGWEBSITEFEATUREGQLSCHEMA } from "../../lib/gql/BettingWebsite.Feature";
import { IBettingWebsiteFeature } from "../../types/BettingWebsite.Feature";
import { IMultiLanguageInputArgs } from "../../types/MultiLanguageInput";

export async function getFeatures(
  limit: number,
  offset: number,
  query: string
): Promise<IBettingWebsiteFeature[]> {
  let filters = "";
  if (query && query.trim() !== "") {
    filters = `,query:"${query}"`;
  }
  const gqlString = `query{
    GetBettingWebsiteFeatures(limit:${limit},offset:${offset}${filters}){
        ${BETTINGWEBSITEFEATUREGQLSCHEMA}
    }
  }`;

  try {
    const response = await gqlRequest<{
      GetBettingWebsiteFeatures: IBettingWebsiteFeature[];
    }>({
      query: gqlString,
      endpoint: BETTING_WEBSITE_RELATIVES_URL,
      headers: {
        authorization: `Bearer ${getAuthentication()}`,
      },
    });
    if (response.errors && response.errors.length > 0) {
      throw new Error(response.errors[0].message);
    }
    return response?.data?.GetBettingWebsiteFeatures || [];
  } catch (err) {
    throw err;
  }
}

export async function getFeatureByID(
  id: string
): Promise<IBettingWebsiteFeature | null> {
  const gqlString = `query{
        GetBettingWebsiteFeatureByID(id:"${id}"){
            ${BETTINGWEBSITEFEATUREGQLSCHEMA}
        }
    }`;
  try {
    const response = await gqlRequest<{
      GetBettingWebsiteFeatureByID: IBettingWebsiteFeature;
    }>({
      query: gqlString,
      endpoint: BETTING_WEBSITE_RELATIVES_URL,
      headers: {
        authorization: `Bearer ${getAuthentication()}`,
      },
    });
    if (response.errors && response.errors.length > 0) {
      throw new Error(response.errors[0].message);
    }
    return response?.data?.GetBettingWebsiteFeatureByID || null;
  } catch (err) {
    throw err;
  }
}

export async function addNewFeature(
  feature: IMultiLanguageInputArgs
): Promise<IBettingWebsiteFeature | null | undefined> {
  const gqlString = `mutation{
        AddNewBettingWebsiteFeature(feature:{
            en:"${escapeGqlString(feature.en)}",
            ar:"${escapeGqlString(feature.ar)}",
            fr:"${escapeGqlString(feature.fr)}"
        }){
            ${BETTINGWEBSITEFEATUREGQLSCHEMA}    
        }
    }`;

  try {
    const response = await gqlRequest<{
      AddNewBettingWebsiteFeature: IBettingWebsiteFeature;
    }>({
      query: gqlString,
      endpoint: BETTING_WEBSITE_RELATIVES_URL,
      headers: {
        authorization: `Bearer ${getAuthentication()}`,
      },
    });
    if (response.errors && response.errors.length > 0) {
      throw new Error(response.errors[0].message);
    }
    return response?.data?.AddNewBettingWebsiteFeature || null;
  } catch (err) {
    throw err;
  }
}

export async function editFeature(
  id: string,
  feature: IMultiLanguageInputArgs
): Promise<IBettingWebsiteFeature | null> {
  const gqlString = `mutation{
        EditBettingWebsiteFeature(id:"${id}",feature:{
            en:"${escapeGqlString(feature.en)}",
            ar:"${escapeGqlString(feature.ar)}",
            fr:"${escapeGqlString(feature.fr)}"
        }){
            ${BETTINGWEBSITEFEATUREGQLSCHEMA}    
        }
    }`;
  try {
    const response = await gqlRequest<{
      EditBettingWebsiteFeature: IBettingWebsiteFeature;
    }>({
      query: gqlString,
      endpoint: BETTING_WEBSITE_RELATIVES_URL,
      headers: {
        authorization: `Bearer ${getAuthentication()}`,
      },
    });
    if (response.errors && response.errors.length > 0) {
      throw new Error(response.errors[0].message);
    }
    return response?.data?.EditBettingWebsiteFeature || null;
  } catch (err) {
    throw err;
  }
}

export async function deleteFeature(id: string): Promise<boolean | undefined> {
  const gqlString = `mutation{
        DeleteBettingWebsiteFeatureByID(id:"${id}")
    }`;
  try {
    const response = await gqlRequest<{
      DeleteBettingWebsiteFeatureByID: boolean;
    }>({
      query: gqlString,
      endpoint: BETTING_WEBSITE_RELATIVES_URL,
      headers: {
        authorization: `Bearer ${getAuthentication()}`,
      },
    });
    if (response.errors && response.errors.length > 0) {
      throw new Error(response.errors[0].message);
    }
    return response?.data?.DeleteBettingWebsiteFeatureByID;
  } catch (err) {
    throw err;
  }
}
